import { useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { get, isFunction } from 'lodash';

export function useSearch(props: Search.ISearchHookProps) {
  const {
    ref,
    api,
    defaultSelected = get(ref, ['current', 'selectedData']),
    defaultData = get(ref, ['current', 'data']) || [],
    getLabel
  } = props;

  const [selectedData, setSelectedData] = useState(defaultSelected);
  const [data, setData] = useState<Utils.ICRC[]>(defaultData);
  const [dataFormat, setDataFormat] = useState<Utils.ICRC[]>(defaultData);

  const onChange = useCallback(async (place) => {
    if (isFunction(props.onChange)) await props.onChange(place);

    await setSelectedData(place);
  }, [setSelectedData, props.onChange]);

  const getData = useCallback(async (search?: string) => {
    const response = await api(search);

    await setData(response.data);
    await setDataFormat(response.data);

    if (isFunction((props.onUpdate))) await props.onUpdate(search, response.data);
  }, [setData, setDataFormat, props.onUpdate, api]);

  const formatData = useCallback((search?: string) => {
    if (search && isFunction(getLabel)) {
      setDataFormat(data.filter(element => getLabel(element).toLowerCase().indexOf(search.toLowerCase()) > -1));
    } else {
      setDataFormat(data);
    }
  }, [data, setDataFormat, getLabel]);

  useEffect(() => {
    if (!data.length) getData();
  }, []);

  useImperativeHandle(ref, () => ({
    selectedData,
    data: dataFormat,
    reset(selectedValue: any) {
      setSelectedData(selectedValue);
    }
  }), [selectedData, dataFormat]);

  return {
    selectedData,
    data: dataFormat,
    getData,
    onChange,
    formatData
  };
}